import { atomFamily } from "jotai/utils";

import { ClaimHandlingDecision } from "types/DigitalJourneySession";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionClaimHandlingDecisionAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`claimHandlingDecision-${sessionId}`, null as ClaimHandlingDecision | null)
);
export const claimHandlingDecisionAtom = createDerivedSessionAtom<ClaimHandlingDecision | null>(
  sessionClaimHandlingDecisionAtom
);
